function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M71.7,0C63,0,55.2,3.9,50,10.1C44.8,3.9,37,0,28.3,0C12.7,0,0,12.7,0,28.3c0,8.3,3.6,15.8,9.3,21l40.7,40 l40.7-40.1c5.7-5.2,9.3-12.7,9.3-21C100,12.7,87.3,0,71.7,0z M88,46.3L88,46.3l-0.1,0.2L50,83.7L12.1,46.4H12v-0.1 c-5.1-4.6-8-11.2-8-18C4,14.9,14.9,4,28.3,4c7.2,0,14,3.2,18.6,8.7l3.1,3.6l3.1-3.6C57.7,7.1,64.5,4,71.7,4C85.1,4,96,14.9,96,28.3 C96,35.1,93.1,41.7,88,46.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M60.7,34l4.2-4.2L62.1,27l-4.2,4.2c-1.7-1.2-3.6-2-5.7-2.3v-5.1h-4v5.1c-2.4,0.4-4.6,1.4-6.5,2.8l-4.1-4.1 l-2.8,2.8l4.2,4.2c-1.1,1.6-1.9,3.5-2.2,5.6h-6.3v4h6.3c0.3,2.1,1.1,4.1,2.3,5.8l-4.3,4.3l2.8,2.8l4.2-4.2c1.8,1.4,3.9,2.3,6.3,2.7 v5.1h4v-5.1c2-0.3,3.9-1.1,5.5-2.2l4.2,4.2l2.8-2.8l-4.1-4.1c1.5-1.8,2.5-4,2.8-6.4h6.1v-4h-6.1C63.1,37.9,62.1,35.8,60.7,34z  M40.6,42.3c0-5.2,4.3-9.5,9.5-9.5s9.5,4.3,9.5,9.5s-4.3,9.5-9.5,9.5S40.6,47.5,40.6,42.3z"
}));

var SvgHeartSettingsLarge = function SvgHeartSettingsLarge(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 89.3",
    style: {
      enableBackground: "new 0 0 100 89.3"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/heart-settings-large.f791fdc7.svg";
export { SvgHeartSettingsLarge as ReactComponent };